import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { CloseButton } from './close-button';
import { FC } from 'react';
import ImageBoxFuture from './image-box-future';
import { LoadingButton } from '@mui/lab';
import { MUIResponsiveValue } from '@/logic/types';
import { pxToRem } from '@/theme/typography';

export interface DialogModel {
  buttonId: string;
  img: File | string;
  title: string;
  altImage?: string;
  widthImage?: string | MUIResponsiveValue<string>;
  heightImage?: string | MUIResponsiveValue<string>;
  description: string;
  isLoading?: boolean;
  handleOkayClick: () => void;
}

interface ConfirmDialogModel extends DialogModel {
  handleCloseClick: () => void;
  isLoading?: boolean;
}

export const ConfirmDialog: FC<ConfirmDialogModel> = ({
  buttonId,
  img,
  widthImage,
  heightImage,
  altImage,
  title,
  description,
  isLoading = false,
  handleOkayClick,
  handleCloseClick,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <>
      <DialogTitle>
        <CloseButton disabled={isLoading} handleClick={handleCloseClick} />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            alignItems: 'center',
            margin: 'auto',
          }}
        >
          <Box sx={{ marginBlock: 4 }}>
            <ImageBoxFuture
              img={img}
              title={intl.formatMessage({
                id: altImage || 'alt.icon',
              })}
              objectFit='contain'
              sx={{
                width: widthImage || '100px',
                height: heightImage || '100px',
              }}
            />
          </Box>
          <Typography
            sx={{
              color: theme.palette.grey[90],
              fontSize: pxToRem(22),
              fontWeight: 700,
              lineHeight: '33px',
              marginBottom: pxToRem(24),
            }}
          >
            <FormattedMessage id={title} />
          </Typography>
          <Typography
            sx={{
              color: theme.palette.grey[70],
              fontSize: pxToRem(18),
              fontWeight: 400,
              lineHeight: '27px',
              textAlign: 'center',
            }}
          >
            <FormattedMessage id={description} />
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          id={`${buttonId}-cancel`}
          type='button'
          disabled={isLoading}
          fullWidth
          sx={{
            fontFamily: theme.palette.typography.font.bold,
            color: theme.palette.grey[70],
          }}
          onClick={handleCloseClick}
        >
          <FormattedMessage id='global.cancel' />
        </Button>
        <LoadingButton
          id={`${buttonId}-yes`}
          variant='contained'
          fullWidth
          loading={isLoading}
          onClick={handleOkayClick}
          sx={{
            height: {
              tablet: pxToRem(56),
              mobile: '56px',
            },
          }}
        >
          <FormattedMessage id='global.yes' />
        </LoadingButton>
      </DialogActions>
    </>
  );
};
